
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFleetProposal as ObiFleetProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fleet-proposal.js';
 
 
 

 
 export const ObiFleetProposal = createComponent({
   react: React,
   tagName: 'obi-fleet-proposal',
   elementClass: ObiFleetProposalElement,
   events: {
     
   }
  });
 
 